import { formatDate } from '../../utils';

const transformPathwayInstances = ({ results = [] }) =>
  results.map(({ id, pathwayTemplateId, patientId, status, createdAt, updatedAt }) => ({
    id,
    pathwayTemplateId,
    patientId,
    status,
    createdOn: formatDate(createdAt),
    updatedOn: formatDate(updatedAt),
  }));

export default transformPathwayInstances;
